import React, { useState } from 'react';
import { Save, History } from 'lucide-react';
import { fuelRates } from '../mockData';

const FuelRates = () => {
  const [rates, setRates] = useState(fuelRates);

  return (
    <div className="space-y-6 max-w-4xl mx-auto">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Fuel Rates (RSP)</h1>
          <p className="text-slate-500 text-sm mt-1">Update daily petrol and diesel prices</p>
        </div>
        <button className="text-primary-600 hover:text-primary-700 font-medium text-sm flex items-center gap-2">
          <History className="w-4 h-4" /> View History
        </button>
      </div>

      <div className="glass-panel p-6 sm:p-8">
        <div className="flex justify-between items-center mb-8 pb-4 border-b border-slate-100">
          <div>
            <h2 className="text-lg font-semibold text-slate-800">Today's Rates</h2>
            <p className="text-slate-500 text-sm">Valid for {rates.date}</p>
          </div>
          <div className="bg-blue-50 text-blue-700 px-3 py-1 rounded-lg text-sm font-medium">
            Active
          </div>
        </div>

        <form className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="block text-sm font-medium text-slate-700">Petrol (₹/L)</label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 font-medium">₹</span>
                <input 
                  type="number" 
                  step="0.01"
                  className="input-field pl-8 text-lg font-semibold text-slate-900"
                  value={rates.petrol}
                  onChange={(e) => setRates({...rates, petrol: parseFloat(e.target.value)})}
                />
              </div>
            </div>
            
            <div className="space-y-2">
              <label className="block text-sm font-medium text-slate-700">Diesel (₹/L)</label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 font-medium">₹</span>
                <input 
                  type="number" 
                  step="0.01"
                  className="input-field pl-8 text-lg font-semibold text-slate-900"
                  value={rates.diesel}
                  onChange={(e) => setRates({...rates, diesel: parseFloat(e.target.value)})}
                />
              </div>
            </div>
          </div>

          <div className="pt-4 flex justify-end">
            <button type="button" className="btn-primary flex items-center gap-2 px-6">
              <Save className="w-5 h-5" /> Save Rates
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FuelRates;
